import { Text } from "rebass";
import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button } from "../Button";
import { ReactComponent as ForwardIcon } from "../../assets/icons/icon-forward.svg";
import { Modal } from "../Modal";
import { PreliminaryEtrOutageClassification } from "../PreliminaryEtrOutageClassification/PreliminaryEtrOutageClassification";
import { COMPLEX, MAJOR, MINOR, MODERATE } from "../PreliminaryEtrType";

export const MODAL_ID = "outage-p-etr-classification";

const ButtonContainer = styled(Button)`
  font-size: ${({ isLearnMoreLink }) => (isLearnMoreLink ? "14px" : "16px")};
  padding-left: 0;
  color: ${p => p.theme.colors.blueLink};
`;

const TextContainer = styled(Text)`
  margin-bottom: 0;
  margin-top: 0;
`;

const StyledForwardIcon = styled(ForwardIcon)`
  position: relative;
  top: 4px;
  margin-top: -8px;
  row-gap: 1px;
  font-weight: bold;
`;

export const PreliminaryEtrLearnMoreLink = ({
  text,
  preliminaryEtrType,
  testIdPrefix = "Other",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleMount = modalState => modalState.open();
  const handleOnClose = () => setIsModalOpen.apply(false);

  return (
    <>
      <TextContainer>
        <ButtonContainer
          variant="text"
          onClick={handleClick}
          data-testid={`${testIdPrefix}-PreliminaryEtrLearnMoreLink__LearnMoreButton`}
          isLearnMoreLink={text === "Learn more"}
        >
          {text} <StyledForwardIcon />
        </ButtonContainer>
      </TextContainer>

      {isModalOpen && (
        <Modal
          name={MODAL_ID}
          onMount={handleMount}
          onClose={handleOnClose}
          closeButtonVariant="dark"
        >
          {({ close }) => (
            <PreliminaryEtrOutageClassification
              close={close}
              defaultOpenCategory={
                preliminaryEtrType == null || preliminaryEtrType === ""
                  ? MINOR
                  : preliminaryEtrType
              }
            />
          )}
        </Modal>
      )}
    </>
  );
};

PreliminaryEtrLearnMoreLink.propTypes = {
  text: PropTypes.string,
  preliminaryEtrType: PropTypes.oneOf([MINOR, MODERATE, MAJOR, COMPLEX]),
};

PreliminaryEtrLearnMoreLink.defaultProps = {
  text: "Learn more",
  preliminaryEtrType: MINOR,
};
